import React, { useState } from "react";
import "./Layout.css";
import AppNavBar from "../Navbar/Navbar";
import SideNav from "../Sidebar/SideBar";
import { useNavigate } from "react-router-dom";
//pass the child props
function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };
  const logout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");

    setTimeout(() => {
      navigate("/login");
    }, 1000);
  };

  const toggleSidebarCollapsed = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };

  return (
    <div className="layout-container">
      {/* Fixed navbar at top */}
      <div className="navbar-section">
        <AppNavBar onToggleSidebar={toggleSidebar} onLogout={logout} />
      </div>

      {/* Backdrop for mobile overlay */}
      {sidebarOpen && <div className="sidebar-backdrop" onClick={closeSidebar}></div>}

      {/* Main content area with sidebar and content */}
      <div className="main-content">
        <div
          className={`sidebar-section ${sidebarOpen ? "sidebar-open" : ""} ${
            isSidebarCollapsed ? "sidebar-collapsed" : ""
          }`}
        >
          <SideNav
            onClose={closeSidebar}
            isCollapsed={isSidebarCollapsed}
            onToggleCollapse={toggleSidebarCollapsed}
          />
        </div>

        <div className={`content-section ${isSidebarCollapsed ? "content-expanded" : ""}`}>
          {/* this is where the page content will be shown */}
          {children}
        </div>
      </div>
    </div>
  );
}

export default Layout;
